import { render, staticRenderFns } from "./PopDeleteEpro.vue?vue&type=template&id=4ac5f5fb&lang=pug"
import script from "./PopDeleteEpro.vue?vue&type=script&lang=js"
export * from "./PopDeleteEpro.vue?vue&type=script&lang=js"
import style0 from "./PopDeleteEpro.vue?vue&type=style&index=0&id=4ac5f5fb&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports